import Util from '@/utils/util'
import Axs from '@/utils/axs'
import {defineStore} from 'pinia'
import storeInfoFun from '@/info.js'
import { ElMessage } from "element-plus";

let storeFunc = defineStore("zhsq2/communitys",{
    state:()=>{
        return {
           //业务数据  count:99

            TypeEnum: [{
                id: 0,
                label: "无"
            },
            {
                id: 1,
                label: "住宅社区"
            },
            {
                id: 2,
                label: "街道委员会"
            },
            {
                id: 3,
                label: "单位社区"
            },
            {
                id: 4,
                label: "乡镇社区"
            }
            ,
            {
                id: 5,
                label: "商住社区"
            }
            ,
            {
                id: 6,
                label: "其他团体社区"
            }
        ],

        }
    },
    actions:{

        getTempDataForSelect(callback,failback, forceload)
        {
         
            //debugger;
             if(!forceload &&  !Util.isEmpty(this.tempDataForSelect))
             {
                 if(callback)
                 {
                     callback(this.tempDataForSelect)
                 }
                 return;
             }

          
             let storeInfo = storeInfoFun();
             let url = storeInfo.linkUrl + "api/zhsq/communitys/loadAll";
           
             Axs.get(url, {}, null, (req) => {
                
                 let data = req.data;
                 this.tempDataForSelect = []
                 data.forEach(element => {
                     let selectObj = {
                         id:element.id,
                         label:element.name,
                         value:element,
                         disabled:false
                     }
                     this.tempDataForSelect.push(selectObj);
                 });
                 if(callback)
                 {
                     callback(this.tempDataForSelect)
                 }
             }, (err) => {
                
                 if(failback)
                 failback(err)
             },undefined,true)
        },
        clearTempDataForSelect()
        {
             this.tempDataForSelect = null;
        },
 
         getTempDataByID(id) {
            //  if (Util.isEmpty(this.tempDataForSelect))
            //  {
            //      this.getTempDataForSelect()
            //  }
             if (Util.isEmpty(this.tempDataForSelect))
             {
                 return null;
             }
             let find = null
             this.tempDataForSelect.forEach(element => {
                if (Number(element.id) == Number(id))
                     find = element;
             });
             return find;
         },

         async loadDataByIDAsync(id) {
           // console.log("loadDataByIDAsync==>??????????????id=",id);
            if(Util.isEmpty(id))
            {
                return null
            }
            let storeInfo = storeInfoFun();
            let url = storeInfo.linkUrl + "api/zhsq/communitys/load";
            let ret =  await Axs.getAsync(url, {id})
            if(Util.isEmpty(ret))
                return null
            if(ret.status != 200)
            {
                ElMessage({type: "error",message:ret.message});
                return null;
            }
         
            let retData = null
            let data = ret.data;
            if(data.length > 0)
                retData = data[0]
            return retData
         },
         
        async unBindAppUser(id,callback,failback)
        {
            let storeInfo = storeInfoFun();
            let url = storeInfo.linkUrl + "api/zhsq/communitys/unBindAppUser";
            let req = await Axs.postAsync(url, {id},{})
            if(Util.isEmpty(req))
                return;
            if(req.status != 200)
            {
                ElMessage({type: "error",message:req.message});
                return;
            }
            ElMessage({type: "info",message:"解绑成功!"});
            if(!Util.isEmpty(callback))
            {
                callback(req);
            }
        }
            
    
        //方法
        // doSum()
        // {
        //     this.count++
        // }
    },
    getters:{
        //计算属性，只读属性
    },
    persist: false
})

 //组合式写法 mixin混合写法
// let storeFunc = defineStore("user",()=>{
//     //组合式写法
//     let p = ref("xx");
//     return {
//         p
//     }
// })


export default storeFunc